






































































































































































































































































import { Component, Prop, Watch, Vue, Ref } from "vue-property-decorator";
import { Getter } from "vuex-class";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import { ListModel } from "@/shared/models/listModel";
import { PaymentMean } from "@/shared/models/paymentMean";
import { CardType } from "@/shared/models/cardType";
import { Currency } from "@/shared/models/currency";
import { PaymentModel } from "./types";
import CustomerLookup from "@/components/misc/CustomerLookup.vue";
import VCustomer, { CustomerModel } from "@/shared/models/vCustomer";
import { VFinancialDocument } from "@/shared/models/VFinancialDocument";
import {
  FinancialDocumentTypesEnum,
  ReservationStatusEnum,
} from "@/shared/models/enums.type";
import { PaymentMeansEnum } from "@/shared/models/enums.type";
import _ from "lodash";
import { Prepayment } from "@/shared/models/prepayment";
import FinDocPrepaymentsModal from "../misc/FinDocPrepaymentsModal.vue";
import { FinancialSettingsType } from "@/store/modules/financial";
import NumericInputImproved from "../numbers/NumericInputImproved.vue";
import { BusinessUnit } from "@/shared/models/businessUnit";
import { CashRegisterModel } from "@/shared/models/cashRegister";
import FinancialDocumentModalForm from "../finances/FinancialDocumentModalForm.vue";
import InvoiceRoutingModal from "@/components/finances/InvoiceRoutingModal/InvoiceRoutingModal.vue";
import RequireRole from "@/components/misc/RequireRole.vue";
import { JwtClaims } from "@/store/modules/auth";
import { userCanCreateFinancialDocuments } from "@/shared/roles";
import { CreateAdvanceInvoiceForPaymentsResultModel } from "../finances/FinancialDocumentFormParts/models";
import DateTimeOffsetField from "@/components/misc/DateTimeOffsetField.vue";

@Component({
  components: {
    RightDrawer,
    NumericInputImproved,
    CustomerLookup,
    FinDocPrepaymentsModal,
    FinancialDocumentModalForm,
    InvoiceRoutingModal,
    RequireRole,
    DateTimeOffsetField,
  },
})
export default class ReservationFormPaymentForm extends Vue {
  @Getter("appParams/isCardTypeRequiredForCardPaymentMeans")
  isCardTypeRequiredForCardPaymentMeans?: boolean;

  @Prop({ default: false }) open!: boolean;
  @Prop() model?: PaymentModel | null;
  @Prop() paymentId?: number | null;
  @Prop() reservationId?: number | null;
  @Prop() reservationStatusId?: number | null;
  @Prop() callback!: () => any;

  @Prop({ default: true }) allowAssignmentToFinDoc?: boolean;
  messages: string[] = [];

  fkey = 0;
  saving = false;
  loading = false;
  lookupOpen = false;
  isCurrencyHistoric = false;
  generateAdvanceInvoiceChecked = true;

  initialPayment: PaymentModel = new PaymentModel();
  payment: PaymentModel = new PaymentModel();
  changeReservationStatus = false;

  mounted() {
    this.changeReservationStatus =
      this.confirmReservation &&
      (this.automaticallyChangeReservationStatusToConfirmed ?? false);
  }

  @Getter("codebooks/paymentMeans") paymentMeans?: PaymentMean[];
  @Getter("codebooks/cardTypes") cardTypes?: CardType[];
  @Getter("appParams/workingCurrency") workingCurrency?: Currency;
  @Getter("appParams/formalCurrency") formalCurrency?: Currency;
  @Getter("financial/settings") storedSettings?: FinancialSettingsType;
  @Getter("appParams/showUnpaidPrepaymentsModal")
  showUnpaidPrepaymentsModal?: boolean;

  @Getter("appParams/cashRegisterFeatureFlag")
  cashRegisterFeatureFlag?: boolean;
  @Getter("appParams/automaticallyChangeReservationStatusToConfirmed")
  automaticallyChangeReservationStatusToConfirmed?: boolean;
  @Getter("auth/claims") claims?: JwtClaims;

  @Getter("businessUnit/activeBusinessUnit") activeBusinessUnit?: BusinessUnit;
  @Getter("cashRegister/activeCashRegister")
  activeCashRegister?: CashRegisterModel;
  financialDocumentTypesEnum = FinancialDocumentTypesEnum;

  get allowedCurrencies() {
    if (this.isPaymentHistoric) {
      return [
        this.workingCurrency,
        this.formalCurrency,
        this.storedSettings?.historicCurrency,
      ];
    }
    return [this.workingCurrency, this.formalCurrency];
  }

  @Watch("open")
  async openWatch(fresh: boolean, old: boolean) {
    if (fresh && !old) {
      this.fkey++;

      if (this.paymentId) {
        await this.loadPayment();
      } else if (this.model) {
        this.payment = _.cloneDeep(this.model);
      }

      await this.getCustomer();
    }

    this.getPreviousDocuments();

    if (!this.paymentId && this.previousDocuments.length === 1) {
      this.setDefaultDocument();
    }

    this.setDefaultCurrency();

    this.initialPayment = _.cloneDeep(this.payment);

    this.generateAdvanceInvoiceChecked =
      fresh &&
      !this.createAdvanceInvoiceFactors.hasSelectedDocToAssign &&
      this.createAdvanceInvoiceFactors.canCreateFinDocs &&
      !this.payment.id;
  }

  get createAdvanceInvoiceFactors() {
    return {
      hasSelectedDocToAssign: !!this.payment.financialDocumentId,
      canCreateFinDocs: this.canCreateFinDocs,
    };
  }

  @Watch("createAdvanceInvoiceFactors", { immediate: true, deep: true })
  createAdvanceInvoiceFactorsWatch(
    fresh: typeof ReservationFormPaymentForm.prototype.createAdvanceInvoiceFactors
  ) {
    if (fresh.hasSelectedDocToAssign || !fresh.canCreateFinDocs)
      this.generateAdvanceInvoiceChecked = false;
  }

  isFormValid = false;
  get submitDisabled(): boolean {
    return this.isFormValid && !this.loading && !this.saving;
  }

  get paymentMeanBaseId() {
    return this.paymentMeans?.find(
      (e) => e.id === this.payment.paymentMeansId
    )?.paymentMeanBaseId;
  }

  get cardTypeDisplay() {

    if (
      (this.payment.paymentMeansId &&
        (this.payment.paymentMeansId == PaymentMeansEnum.KreditnaKartica ||
          this.payment.paymentMeansId == PaymentMeansEnum.BankovnaKartica)) ||
      (this.paymentMeanBaseId &&
        (this.paymentMeanBaseId== PaymentMeansEnum.KreditnaKartica ||
          this.paymentMeanBaseId == PaymentMeansEnum.BankovnaKartica))
    ) {
      return true;
    } else {
      this.payment.cardTypeId = null;
      return false;
    }
  }

  get rules() {
    return {
      required: (value: any) => !!value || this.$t("Validation.Required"),
      positive: (value: any) => {
        if (value === undefined || value === null || value === "") {
          return true;
        }
        return +value > 0 || this.$t("Validation.MustBePositive");
      },
      negative: (value: any) =>
        +value <= 0 || this.$t("Validation.MustBeNegative"),
      reservationHolder: (value: any) =>
        !!value || this.$t("Reservation.HolderIsRequired"),
      cardTypeIsRequired: (value: any) => {
        if (this.cardTypeDisplay) {
          return !!value || this.$t("Validation.Required");
        }
      },
    };
  }

  selected(customer: VCustomer) {
    if (this.payment) {
      this.payment.customerId = customer.id;
      this.payment.customerName = customer.name;
    }
  }

  get filterPrefil() {
    return {
      name: this.payment?.customerName || "",
    };
  }

  get confirmReservation() {
    if (
      !this.paymentId &&
      this.reservationStatusId == ReservationStatusEnum.Hold
    ) {
      this.changeReservationStatus =
        this.automaticallyChangeReservationStatusToConfirmed ?? false;
      return true;
    } else {
      this.changeReservationStatus = false;
      return false;
    }
  }

  get isFinancialDocumentCancelled() {
    if (this.payment.financialDocumentId) {
      return (
        this.previousDocuments.find(
          (x) => x.financialDocumentId === this.payment.financialDocumentId
        )?.typeId == FinancialDocumentTypesEnum.Storno
      );
    }

    return false;
  }

  get availableCardTypes() {
    if (!this.cardTypes) return [];

    return this.cardTypes.filter((c) => {
      if (this.payment?.cardTypeId === c.id) return true;
      return !c.name.includes('- VCC');
    });
  }

  previousDocuments = [] as VFinancialDocument[];
  getPreviousDocuments() {
    if (this.allowAssignmentToFinDoc) {
      this.loading = true;
      const reservationId = this.reservationId;
      const statusIdsExcluded = [1]; // status can not be "U izradi"
      const documentTypeIdsExcluded = [2]; // document type can not be "Ponuda"
      this.axios
        .get<ListModel<VFinancialDocument>>("/financialDocuments", {
          params: {
            $top: 1000,
            reservationId: reservationId,
            statusIdsExcluded: statusIdsExcluded.join(","),
            documentTypeIdsExcluded: documentTypeIdsExcluded.join(","),
          },
        })
        .then((x) => {
          this.previousDocuments = x.data.result;
        })
        .finally(() => {
          this.loading = false;
        });
    } else {
      this.previousDocuments = [];
    }
  }

  setDefaultDocument() {
    this.payment.financialDocumentId =
      this.previousDocuments[0].financialDocumentId;
    this.payment.paymentMeansId = this.previousDocuments[0].paymentMeansId;
    this.payment.cardTypeId = this.previousDocuments[0].cardTypeId;
  }

  unpaidPrepayments: ListModel<Prepayment> = {
    count: 0,
    result: [],
  };

  unpaidPrepaymentsModalOpen = false;

  async loadPayment() {
    this.loading = true;
    await Vue.axios
      .get<any>("/payments/" + this.paymentId)
      .then((res) => {
        this.payment = res.data;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  refresh() {
    if (this.callback instanceof Function) {
      this.callback();
    }
  }

  @Ref("drawer") rightDrawer?: RightDrawer;

  close() {
    this.rightDrawer?.clickOverlay();
  }

  setDefaultCurrency() {
    if (this.isPaymentHistoric) {
      this.isCurrencyHistoric = true;
      this.payment.currencyId =
        this.storedSettings?.historicCurrency?.id ?? null;
    } else {
      this.payment.currencyId = this.formalCurrency?.id || null;
    }
  }

  get isPaymentHistoric() {
    return (
      this.storedSettings?.historicCurrency &&
      this.storedSettings?.historicCurrency.id === this.payment.currencyId &&
      this.payment.currencyId !== this.workingCurrency?.id &&
      this.payment.currencyId !== this.formalCurrency?.id
    );
  }

  async getCustomer() {
    this.loading = true;
    if (this.payment.customerId) {
      const id = this.payment.customerId;
      await this.axios
        .get<CustomerModel>("/customers/" + id)
        .then((res) => {
          this.payment.customerName = res.data.isLegalEntity
            ? res.data.legalEntityName ?? ""
            : res.data.firstName + " " + res.data.lastName;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  async save(issuePaidInvoice = false) {
    if (this.payment.id) {
      await this.update();
      return;
    } else {
      await this.create(issuePaidInvoice);
      return;
    }
  }

  async create(issuePaidInvoice = false) {
    this.loading = true;
    this.payment.paymentMeanBaseId = this.paymentMeanBaseId ?? null;
    await this.axios
      .post("/payments", {
        ...this.payment,
        changeReservationStatusToConfirmed: this.changeReservationStatus,
      })
      .then((response) => {
        this.initialPayment = _.cloneDeep(this.payment);
        this.$store.dispatch("showNotification", {
          color: "success",
          message: issuePaidInvoice
            ? this.$t("Payment.SaveAndGeneratedDoc")
            : this.$t("Payment.SaveSuccess"),
          timeout: 5000,
          localize: true,
        });
        if (issuePaidInvoice) {
          this.generateAdvanceInvoice(response.data);
        }
      })
      .finally(() => {
        if (!issuePaidInvoice) {
          this.$emit("saved");
          this.$emit("update:open", false);
          this.refresh();
          this.changeReservationStatus =
            this.confirmReservation &&
            (this.automaticallyChangeReservationStatusToConfirmed ?? false);
        }
      });
  }

  async update() {
    this.payment.paymentMeanBaseId = this.paymentMeanBaseId ?? null;
    await this.axios
      .put("/payments", { ...this.payment })
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("Payment.SaveSuccess"),
          timeout: 5000,
          localize: true,
        });
      })
      .finally(() => {
        this.$emit("saved");
        this.$emit("update:open", false);
        this.refresh();
      });
  }

  async createOrUpdate() {
    if (this.payment.id) {
      await this.update();
      return;
    } else {
      await this.create();
      return;
    }
  }

  get canCreateFinDocs() {
    return userCanCreateFinancialDocuments()(this.claims);
  }

  invoiceRoutingReservationId: number | null = null;
  invoiceRoutingCustomerId: number | null = null;
  invoiceRoutingCustomerName = "";
  invoiceRoutingCustomerOib = "";
  invoiceRoutingPaymentMeansId: number | null = null;
  invoiceRoutingCardTypeId: number | null = null;
  invoiceRoutingOpen = false;
  invoiceEditingOpen = false;
  financialDocumentId: number | null = null;
  financialDocumentModalOpen = false;
  autoDeleteDocument = false;

  async generateAdvanceInvoice(paymentId: number | null) {
    if (!this.activeBusinessUnit || !this.activeCashRegister) {
      this.$store.dispatch("showNotification", {
        color: "success",
        message:
          "FinancialDocument.CreationValidation.MustSelectBusinessUnitAndCashRegister",
        timeout: 5000,
        localize: true,
      } as unknown as Notification);
      return;
    }

    this.loading = true;
    const invoiceRoutingCheck = await Vue.axios.post<any>(
      "financialDocuments/CheckIfPaymentsNeedInvoiceRouting",
      {
        paymentId: paymentId,
      }
    );
    if (invoiceRoutingCheck.data.isRoutingNeeded) {
      this.invoiceRoutingReservationId = invoiceRoutingCheck.data.reservationId;
      this.invoiceRoutingCustomerId = invoiceRoutingCheck.data.customerId;
      this.invoiceRoutingCustomerName = invoiceRoutingCheck.data.customerName;
      this.invoiceRoutingCustomerOib = invoiceRoutingCheck.data.customerOib;
      this.invoiceRoutingPaymentMeansId =
        invoiceRoutingCheck.data.paymentMeansId;
      this.invoiceRoutingCardTypeId = invoiceRoutingCheck.data.cardTypeId;
      this.invoiceRoutingOpen = true;
      this.$emit("saved");
      this.$emit("update:open", false);
    }
    // create a document, lock it and pay it
    else {
      await Vue.axios
        .post<CreateAdvanceInvoiceForPaymentsResultModel>(
          "financialDocuments/CreateAdvanceInvoiceForPayments",
          {
            paymentId: paymentId,
            reservationId: this.reservationId,
            businessUnitId: this.activeBusinessUnit.id,
            cashRegisterId: this.activeCashRegister.id,
            showOwnerDetails: true,
            defaultToPropertyBusinessUnit: true,
          }
        )
        .then((res) => {
          this.$store.dispatch("showNotification", {
            color: "success",
            message: this.$t("Payment.SuccessfullyCreatedPaidInvoice"),
            timeout: 5000,
            localize: true,
          });
          if (res.data.locked)
            this.messages.push("FinancialDocument.LockSuccess");
          if (res.data.fiscalized)
            this.messages.push("FinancialDocument.FiscalizationSuccess");
          if (res.data.paid) {
            this.messages.push("FinancialDocument.MarkAsPaidSuccess");
          }
        })
        .catch(() => {
          this.$store.dispatch("showNotification", {
            color: "error",
            message: this.$t("PrepaymentDirectCharge.Error.Unknown"),
            timeout: 5000,
          } as unknown as Notification);
        })
        .finally(() => {
          this.loading = false;
          this.$emit("saved");
          this.$emit("update:open", false);
          this.showMessages();
          this.refresh();
        });
    }
  }

  showMessages() {
    this.loading = false;
    const formatSuccessMessages = (x: string[]) =>
      x
        .map((h) => this.$t(h).toString())
        .map((th) => (th.endsWith(".") ? th : th + "."))
        .join(" ");

    const fiscalizationFailed = this.messages.findIndex(
      (x) => x === "FinancialDocument.FiscalizationFailed"
    );

    if (fiscalizationFailed !== -1) {
      this.messages.splice(fiscalizationFailed, 1);
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("FinancialDocument.FiscalizationFailed"),
        timeout: 5000,
      });
    }

    const ownersInvoicesCreationFailed = this.messages.findIndex(
      (x) => x === "FinancialDocument.CreateOwnersInvoices.NoInvoicesCreated"
    );
    if (ownersInvoicesCreationFailed !== -1) {
      this.messages.splice(ownersInvoicesCreationFailed, 1);
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t(
          "FinancialDocument.CreateOwnersInvoices.NoInvoicesCreated"
        ),
        timeout: 5000,
      });
    }

    const ownersInvoicesLockingFailed = this.messages.findIndex(
      (x) => x === "FinancialDocument.CreateOwnersInvoices.LockingFailed"
    );
    if (ownersInvoicesLockingFailed !== -1) {
      this.messages.splice(ownersInvoicesLockingFailed, 1);
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t(
          "FinancialDocument.CreateOwnersInvoices.LockingFailed"
        ),
        timeout: 5000,
      });
    }

    if (this.messages.length > 0) {
      this.$store.dispatch("showNotification", {
        color: "success",
        message: formatSuccessMessages(this.messages),
        timeout: 5000,
      });
    }

    this.messages = [];

    this.$emit("refresh");
  }
}
